import { TextLanguage, TranslatedText } from "Store/texts/interfaces";

import { replacePlaceholder } from "Utils/replacePlaceholder";
import { ProductCategory } from "../valuablesConstants";
import type { ValuablesText } from "../valuablesInterface";

type Labels = Record<string, TranslatedText>;

export const extractLabels = (
  texts: ValuablesText,
  product: ProductCategory,
): Labels => {
  const labels: Labels = {};
  const { formText, types } = texts;
  const keys = Object.keys(formText);

  keys.forEach((key) => {
    const label = formText[key].label;
    labels[key] = {
      [TextLanguage.NORWEGIAN_BOKMAAL]: replacePlaceholder(
        label[TextLanguage.NORWEGIAN_BOKMAAL],
        {
          product:
            types[product]?.[TextLanguage.NORWEGIAN_BOKMAAL].toLowerCase(),
        },
      ),
      [TextLanguage.ENGLISH]: replacePlaceholder(label[TextLanguage.ENGLISH], {
        product: types[product]?.[TextLanguage.ENGLISH].toLowerCase(),
      }),
    };
  });

  return labels;
};
